
import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import '../../apis/base';
import './marquee.scss';

export default withTranslation()(class Marquee extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  // eslint-disable-next-line
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.scrollStatus !== this.props.scrollStatus) {
      if (!nextProps.scrollStatus) {
        clearInterval(this.startScroll);
        const index = this.props.index ? this.props.index : 0;
        document.getElementsByClassName('scrollobj')[index].scrollLeft = 0;
      } else {
        this.start();
      }
    }
  }
  componentWillUnmount() {
    clearInterval(this.startScroll);
  }

  scroll() {
    let obj = document.getElementsByClassName('scrollobj');
    let scrollText = document.getElementsByClassName('scrollText');
    const index = this.props.index ? this.props.index : 0;
    //　当滚动条滚动了初始内容的宽度时滚动条回到最左端
    if (scrollText[index].offsetWidth <= obj[index].offsetWidth) {
      obj[index].scrollLeft = 0;
    } else {
      // 往左
      // eslint-disable-next-line
      const tmp = obj[index].scrollLeft++;
      //　当滚动条到达右边顶端时
      if (obj[index].scrollLeft === tmp) {
        if (window.navigator.userAgent) {
          const tempArray = navigator.userAgent.toLowerCase().match(/chrome\/([\d.]+)/);
          // if (!tempArray) return;
          if (tempArray && tempArray[1] && tempArray[1].substring(0, 2) === '53') {
            scrollText[index].innerHTML += `&nbsp; ${scrollText[index].innerHTML}`;
          } else {
            scrollText[index].innerHTML += `&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; ${scrollText[index].innerHTML}`;
          }
        } else {
          scrollText[index].innerHTML += `&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; ${scrollText[index].innerHTML}`;
        }
      }
    }
    obj = null;
    scrollText = null;
    // 往上
    // const tmp = (obj.scrollTop)++;
    // if (obj.scrollTop == tmp) {
    // obj.innerHTML += obj.innerHTML;
    // }
    // if (obj.scrollTop >= obj.firstChild.offsetWidth) {
    // obj.scrollTop = 0;
    // }
  }
  start() {
    this.startScroll = setInterval(() => {
      this.scroll();
    }, 15);
  }
  render() {
    return (
      <div className="scrollobj" style={{ width: `${this.props.mainWidth / global.constants.rootValue}rem` }}>
        <span className='scrollText'>
          {this.props.children}
        </span>
      </div>
    );
  }
});
